import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { dialogFormColumn } from '../../theme/mixins';

export const dialogTitleStyles: SxProps<Theme> = { fontWeight: 700, pb: 1, pr: 7 };

export const closeIconStyles: SxProps<Theme> = { position: 'absolute', right: 8, top: 8 };

export const descriptionStyles: SxProps<Theme> = { color: 'text.secondary', mb: 2 };

export const formAlertStyles: SxProps<Theme> = { mb: 2, borderRadius: 3 };

export const fieldsBoxStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    pt: 1,
};

export const namesBoxStyles: SxProps<Theme> = {
    display: 'flex',
    gap: 2,
    flexDirection: { xs: 'column', sm: 'row' },
};

export const dialogActionsStyles: SxProps<Theme> = { px: 3, pb: 3, pt: 1 };

/** Lets the fields scroll under a pinned footer -- see `dialogFormColumn`. */
export const dialogFormStyles: SxProps<Theme> = dialogFormColumn;
